export default __webpack_public_path__ + "static/media/gallery-wip-handle_02.94303688.jpg";